import { useEffect, useState } from 'react'

export interface RegisteredUserLite {
  email: string
  username: string
  role: string
}

/**
 * Ambil daftar user terdaftar dari GET /api/users (sumber: data/users.json).
 * Dipakai untuk mengisi dropdown PIC.
 */
export function useRegisteredUsers() {
  const [users, setUsers] = useState<RegisteredUserLite[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let active = true
    fetch('/api/users')
      .then((r) => (r.ok ? r.json() : []))
      .then((data: unknown) => {
        if (active) setUsers(Array.isArray(data) ? (data as RegisteredUserLite[]) : [])
      })
      .catch(() => {
        if (active) setUsers([])
      })
      .finally(() => {
        if (active) setLoading(false)
      })
    return () => {
      active = false
    }
  }, [])

  return { users, loading }
}
